<div class="row counter-wrapper">
  <div class="col-lg-3 col-md-6 pr-0 float-left m-res-bottom p-res-right cursor-pointer" (click)="navigate('/carts')">
    <div class="counters-section d-flex align-items-center rounded col-lg-12 col-md-12 p-4 color-white-bg">
      <div class="col-lg-2 p-0 counter-icons float-left">
        <i class="fas fa-shopping-cart"></i>
      </div>
      <div class="counter-disc col-lg-10 float-right text-right p-0">
        <h4 class="color-white m-0 w-100 col-lg-12 p-0 font-weight-normal">{{ 'counter.cartsCount' | cxTranslate }}</h4>
        @if (openCartsCount$ | async; as openCartsCount) {
        <h1 class="color-white m-0 w-100 col-lg-12 pt-2 pl-0 pr-0">
          {{ openCartsCount[0].characteristicValue }}
        </h1>
        }
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 pr-0 float-left m-res-bottom p-res-right cursor-pointer" (click)="navigate('/carts')">
    <div class="counters-section d-flex align-items-center rounded col-lg-12 col-md-12 p-4 color-white-bg">
      <div class="col-lg-2 p-0 counter-icons float-left">
        <i class="fas fa-dollar-sign"></i>
      </div>
      <div class="counter-disc col-lg-10 float-right text-right p-0 p-res-right">
        <h4 class="color-white m-0 w-100 col-lg-12 p-0 font-weight-normal">{{ 'counter.cartsValue' | cxTranslate }}</h4>
        @if (cartsValue$ | async; as cartsValue) {
        <h1 class="color-white m-0 w-100 col-lg-12 pt-2 pl-0 pr-0">
          {{ cartsValue[0].characteristicValue }}
        </h1>
        }
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 pr-0 float-left m-res-bottom p-res-right cursor-pointer" (click)="navigate('/quotes')">
    <div class="counters-section d-flex align-items-center rounded col-lg-12 col-md-12 p-4 color-white-bg">
      <div class="col-lg-2 p-0 counter-icons float-left">
        <i class="fas fa-file-alt"></i>
      </div>
      <div class="counter-disc col-lg-10 float-right text-right p-0">
        <h4 class="color-white m-0 w-100 col-lg-12 p-0 font-weight-normal">
          {{ 'counter.quotesCount' | cxTranslate }}
        </h4>
        @if (quotesCount$ | async; as quotesCount) {
        <h1 class="color-white m-0 w-100 col-lg-12 pt-2 pl-0 pr-0">
          {{ quotesCount[0].characteristicValue }}
        </h1>
        }
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-6 float-left p-res-right cursor-pointer" (click)="navigate('/quotes')">
    <div class="counters-section d-flex align-items-center rounded col-lg-12 col-md-12 p-4 color-white-bg">
      <div class="col-lg-2 p-0 counter-icons float-left">
        <i class="fas fa-dollar-sign"></i>
      </div>
      <div class="counter-disc col-lg-10 float-right text-right p-0">
        <h4 class="color-white m-0 w-100 col-lg-12 p-0 font-weight-normal">
          {{ 'counter.quotesValue' | cxTranslate }}
        </h4>
        @if (quotesValue$ | async; as quotesValue) {
        <h1 class="color-white m-0 w-100 col-lg-12 pt-2 pl-0 pr-0">
          {{ quotesValue[0].characteristicValue }}
        </h1>
        }
      </div>
    </div>
  </div>
</div>
